<template>
  <div>
    <!-- <p style="font-size: 1.5rem; font-weight: bold">No data found</p> -->
    <el-button @click="applynewitem" type="text">Create new items</el-button>
    <el-button v-if="$store.state.user === 'visitor'" @click="tologin" type="text">Log in</el-button>

    <div v-if="historycol.length > 1">
      <p>You may search from below collections</p>
      <div v-for="x in historycol" :key="x.value">
        <el-button type="text" @click="jumptoclct(x)"> {{ x.label }}</el-button>
      </div>
    </div>

    <div v-html="entrancehtml"></div>
  </div>
</template>

<script>
import { activecollection } from "@/components/utility/indexdb";

export default {
  data() {
    return {
      historycol: [],
      collections: this.$store.state.collections
    };
  },
  computed: {
    entrancehtml(){return this.$store.state.entrancehtml}
  },
  watch: {

  },

  mounted() {
    // var visitedcol = [];
    // //避免错误，检查header是否存在
    // try { activecollection("headers") }
    // catch (err) {
    //   return
    // }
    // activecollection("headers")
    //   .find()
    //   .sort({ _id: 1 })
    //   .toArray((err, doc) => {
    //     doc.forEach((obj) => {
    //       visitedcol.push(obj.collection)
    //     });

    //   });
    if (this.entrancehtml.length<1) {
      this.$axios.post(url + "rendercontentfromfile", { "ejsname": "notfound" })
        .then(r => {
          this.$store.commit("setentrancehtml",r.data)
          // this.remotehtml = r.data
        })
    }

  },
  methods: {
    jumptoclct(collection) {
      let obj = { collection: collection, model: "generalsearch", value: "" };
      this.$axios.jumptoclct(obj);
    },
    applynewitem() {
      this.$router.push("/edit");
    },
    tologin() {
      this.$router.push("/login");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/entrance.vue